import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { variables } from '../../variables';

@customElement('two-pane-with-header')
export class TwoPaneWithHeader extends LitElement {
  static override styles = [
    variables,
    css`
      :host {
        display: grid;
        grid-template-columns: 30% 70%;
        grid-template-rows: 50px auto;

        height: 100%;
      }

      .header {
        display: flex;
        padding: 0 32px 0 32px;
        align-items: center;

        grid-column-start: 1;
        grid-column-end: 3;

        background: var(--gray-300);
        border-width: 1px 1px 0 1px;
        border: var(--gray-300) solid;

        font-weight: 500;
        font-size: 20px;
        line-height: 24.4px;
      }
    `,
  ];

  override render() {
    return html`<div class="header"><slot name="header">Header</slot></div>
        <slot name="left">Left</slot>
        <slot name="right">Right</slot>
      </div>`;
  }
}
